module.exports = __webpack_public_path__ + "static/media/IMG_6961 edit.cd878aac.jpg";